var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import Box from "../box/Box";
import { placeholderSrc } from "../image/shared";
var lazyOptions = {
    triggerOnce: true,
    rootMargin: "300px 0px",
};
function Embed(_a) {
    var src = _a.src, _b = _a.width, width = _b === void 0 ? "640" : _b, _c = _a.height, height = _c === void 0 ? "360" : _c, title = _a.title, _d = _a.lazyLoad, lazyLoad = _d === void 0 ? true : _d, rest = __rest(_a, ["src", "width", "height", "title", "lazyLoad"]);
    var _e = useInView(lazyOptions), ref = _e[0], inView = _e[1];
    var _f = useState(false), isLoaded = _f[0], setLoaded = _f[1];
    return (React.createElement(Box, { display: "flex" },
        React.createElement(Box, __assign({}, rest, { ref: ref, style: {
                flex: "1 1 0%",
                position: "relative",
                paddingBottom: "calc(".concat(height, " / ").concat(width, " * 100%)"),
                overflow: "hidden",
                background: "#000 url(https://onnits3.imgix.net/interface/loading-light.gif) no-repeat 50% 50%",
                height: "100%",
            } }), !lazyLoad || inView ? (React.createElement("iframe", { title: title, src: src, style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                transition: "opacity 300ms",
                opacity: isLoaded ? 1 : 0,
            }, onLoad: function () { return setLoaded(true); }, width: width, height: height, frameBorder: "0", allow: "autoplay; fullscreen", allowFullScreen: true })) : (React.createElement("img", { alt: title, src: placeholderSrc([width, height]), width: width, height: height, style: { display: "block", aspectRatio: "16 / 9", width: "100%", height: "auto" } })))));
}
export default Embed;
//# sourceMappingURL=Embed.js.map